export default Object.freeze({
  Evaluation: 1,
  Therapy: 2,
  Equipment: 3,
  Assistant: 4,
  Transportation: 5,
  Barriers: 6,
  UnAvailable: 7,
});
